import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';

import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { SharedProgrammingService, CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { Command } from '../../../common/params/interfaces/command.interface';
import { QSNotificationsService } from './../services/notifications.service';
import { Parameter } from './../../../common/params/interfaces/parameter.interface';
import { NotificationProgrammingContext } from '../services/notifications.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { DeviceEvent } from '../../../common/interfaces/event.interface';
import { Event } from './../../../common/interfaces/event.interface';

interface EmailNotifyModel {
  address: string,
  subject: string,
  message: string,
  includeTimestamp: boolean
}

@Component({
  selector: 'prg-email-notification',
  templateUrl: './email-notification.component.html',
  styleUrls: ['./email-notification.component.less']
})
export class QSEmailNotificationComponent extends BaseRoutingComponent implements OnInit {

  _model: EmailNotifyModel;
  private _command: Observable<Command>;
  private _params: Observable<Parameter[]>;
  private _routeParams: Observable<any>;
  private _ready: Observable<boolean>;

  constructor(
    protected store: Store<{
      notificationsProgramming: NotificationProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _route: ActivatedRoute,
    protected router: Router,
    private _notifications: QSNotificationsService,
    private _shared: SharedProgrammingService,
    private _utils: Utils
  ) {
    super();
    this._notifications.setAgentType('email');
    this._ready = this._shared.isReady;
  }

  ngOnInit() {
    this._model = {
      address: '',
      subject: '',
      message: '',
      includeTimestamp: false
    };

    this._routeParams = <Observable<{ command: string, id: string }>>this._route.params;

    this._command = Observable.combineLatest(
      this._routeParams,
      this.store.select(s => s.notificationsProgramming.commands).filter(c => !!c),
      (routeParams, commands) => {
        let id = parseInt(routeParams.id);
        return commands.find(c => c.command === routeParams.command && c.id === id);
      }
    );

    this._params = this._command.map(c => (!!c) ? c.params : []);
  }

  createNotification() {
    console.log('validate email');
    this._command.take(1).subscribe(command => {

      let params: Parameter[] = [{
        name: 'to',
        type: 'STRING',
        value: this._model.address
      }, {
        name: 'subject',
        type: 'STRING',
        value: this._model.subject
      }, {
        name: 'message',
        type: 'STRING',
        value: this._model.message
      }, {
        name: 'timestamp',
        type: 'INTEGER',
        value: this._model.includeTimestamp ? 1 : 0
      }];

      this._notifications.setActionCommand(command, params);
    })
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/email-notification/email-notification.component.ts